import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import {
  selectTerreni,
  selectIsLoading,
  selectError,
} from "../../../features/terreni/terreniSlice";
import { fetchTerreni } from "../../../features/terreni/terreniThunk";
import { fetchCompanies } from "../../../features/company/companyThunk";

const Terreni = () => {
  const columns = [
    { field: "nome", headerName: "Nome del terreno", width: 262 },
    // { field: "tipologiaTerreno", headerName: "Tipologia di terreno", width: 223 },
    { field: "superficie_totale", headerName: "Sup. Totale (HA)", width: 140 },
    { field: "superficie_coltivata", headerName: "Sup. coltivata (HA)", width: 158 },
    // { field: "percentSupColtivata", headerName: "% Sup. coltivata", width: 140 },
    { field: "altitudine", headerName: "Altitudine (m)", width: 132 },
    { field: "esposizione", headerName: "Esposizione", width: 120 },
    { field: "tipo_suolo", headerName: "Tipo di suolo", width: 115 },
    { field: "irrigazione", headerName: "Irrigazione", width: 110 },
    { field: "sistema_coltivazione", headerName: "Coltivazione", width: 120 },
    { field: "coordinate_gps", headerName: "Coordinate GPS", width: 160 },
    { field: "azioni", headerName: "Azioni", width: 60, sortable: false },
  ];
  const dispatch = useDispatch();
  const terreniData = useSelector(selectTerreni);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  
  useEffect(() => {
    dispatch(fetchCompanies())
  },[])
  useEffect(() => {
    // if (!terreniData.length) {
      dispatch(fetchTerreni());
    // }
  }, [dispatch,selectSelectedCompany]);

  return (
    <div className="pageTemplate">
      {isLoading && <p>Loading...</p>}
      {/* {error && <p style={{ color: "red" }}>Error: {error}</p>} */}
      <Table data={terreniData} columns={columns} navData={"terreni" } deleteFunctions={"deleteTerreni"}/>
    </div>
  );
};

export default Terreni;
